import DynamicRoutes from '@lib/routes/DynamicRoutes'
import type { FacetType } from '../const'
import { FACET_ORDER, FACET_PREFIX_MAP, LOCATION_FACETS } from '../const'
import createFacetFiltersFromSlug from './createFacetFiltersFromSlug'

export default function deleteFacetFilterFromSlug({
  facet,
  slug,
}: {
  facet: FacetType
  slug: string | null
}) {
  if (!slug) return

  // Remove leading "/ct/" if present
  const cleanSlug = slug.replace(/^\/ct\//, '')

  const currentFacets = createFacetFiltersFromSlug(cleanSlug)

  // If this is a location facet, Clobber other location facets
  if (LOCATION_FACETS.includes(facet as any)) {
    LOCATION_FACETS.forEach((locationFacet) => {
      delete currentFacets[locationFacet]
    })
  } else {
    delete currentFacets[facet]
  }

  const segments: string[] = []
  for (const facet of FACET_ORDER) {
    if (facet === 'paid') {
      if (currentFacets.paid) {
        segments.push(FACET_PREFIX_MAP.paid)
      }
    } else {
      const val = currentFacets[facet]
      if (val) {
        const prefix = FACET_PREFIX_MAP[facet]
        segments.push(`${prefix}${val}`)
      }
    }
  }

  const newSlug = segments.join('-')

  // Return the ct route
  return DynamicRoutes.search(newSlug)
}
